
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { name: 'ホーム', path: '/' },
    { name: '当院について', path: '/#about' },
    { name: '求人情報', path: '/#recruitment' },
    { name: '事業案内', path: '/#services' },
    { name: '実績', path: '/#testimonials' },
    { name: 'お問い合わせ', path: '/#contact' }
  ];

  const handleLinkClick = (path: string) => {
    if (path.startsWith('/#')) {
      const sectionId = path.substring(2);
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (path === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* ロゴ */}
          <div className="flex-shrink-0">
            <Link to="/" className="text-2xl font-bold text-[#3cb371]" style={{ fontFamily: '"Pacifico", serif' }}>
              整骨院
            </Link>
          </div>

          {/* デスクトップメニュー */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => handleLinkClick('/')} className="text-gray-700 hover:text-[#3cb371] transition-colors cursor-pointer">ホーム</button>
            <a href="#about" className="text-gray-700 hover:text-[#3cb371] transition-colors">当院について</a>
            <a href="#services" className="text-gray-700 hover:text-[#3cb371] transition-colors">診療メニュー</a>
            <a href="#testimonials" className="text-gray-700 hover:text-[#3cb371] transition-colors">お客様の声</a>
            <a href="#recruitment" className="text-gray-700 hover:text-[#3cb371] transition-colors">求人情報</a>
            <a href="#contact" className="text-gray-700 hover:text-[#3cb371] transition-colors">お問い合わせ</a>
          </nav>

          {/* モバイルメニューボタン */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-[#3cb371] hover:bg-gray-100 cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                {isMenuOpen ? (
                  <i className="ri-close-line text-xl"></i>
                ) : (
                  <i className="ri-menu-line text-xl"></i>
                )}
              </div>
            </button>
          </div>
        </div>

        {/* モバイルメニュー */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              {menuItems.map((item) => (
                item.path === '/' ? (
                  <button
                    key={item.name}
                    onClick={() => handleLinkClick(item.path)}
                    className={`block w-full text-left px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 cursor-pointer ${
                      location.pathname === item.path
                        ? 'text-[#3cb371] bg-green-50'
                        : 'text-gray-700 hover:text-[#3cb371] hover:bg-gray-50'
                    }`}
                  >
                    {item.name}
                  </button>
                ) : item.path.startsWith('/#') ? (
                  <button
                    key={item.name}
                    onClick={() => handleLinkClick(item.path)}
                    className="block w-full text-left px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 cursor-pointer text-gray-700 hover:text-[#3cb371] hover:bg-gray-50"
                  >
                    {item.name}
                  </button>
                ) : (
                  <Link
                    key={item.name}
                    to={item.path}
                    className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 cursor-pointer ${
                      location.pathname === item.path
                        ? 'text-[#3cb371] bg-green-50'
                        : 'text-gray-700 hover:text-[#3cb371] hover:bg-gray-50'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                )
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
